import { slideDown } from "@common/slide";
import { scrollToIfNeeded } from "@common/scroll-to";
import IMask from "imask/esm/imask";
import "imask/esm/masked/number";
import "imask/esm/masked/pattern";

const form = document.querySelector(".roi-form");
const results = document.querySelector(".roi-results");
const calculatorData = JSON.parse(form.dataset.json);

const headline = document.querySelector(".roi-headline");
const totalBaseInput = form.querySelector('input[name="total_base"]');
const percentMissPaymentRange = form.querySelector('input[name="percent_miss_payment_range"]');
const percentMissPaymentInput = form.querySelector('input[name="percent_miss_payment"]');
const latePaymentDaysRange = form.querySelector('input[name="late_payment_days_range"]');
const latePaymentDaysInput = form.querySelector('input[name="late_payment_days"]');
const percentMonthlyChurnRange = form.querySelector('input[name="percent_monthly_churn_range"]');
const percentMonthlyChurnInput = form.querySelector('input[name="percent_monthly_churn"]');
const amountOwedInput = form.querySelector('input[name="amount_owed"]');

IMask(totalBaseInput, {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: ",",
  max: Number.MAX_SAFE_INTEGER,
});

const rangeInputFields = [
  {
    input: percentMissPaymentInput,
    range: percentMissPaymentRange,
  },
  {
    input: latePaymentDaysInput,
    range: latePaymentDaysRange,
  },
  {
    input: percentMonthlyChurnInput,
    range: percentMonthlyChurnRange,
  },
];

rangeInputFields.forEach((fields) => {
  const mask = IMask(fields.input, {
    mask: Number,
    scale: 0,
    min: parseInt(fields.range.getAttribute("min")),
    max: parseInt(fields.range.getAttribute("max")),
  });

  fields.range.addEventListener("input", () => {
    fields.input.value = fields.range.value;
    mask.updateValue();
    fields.input.classList.remove("has-error");
  });

  mask.on("complete", () => {
    const value = mask.value || 0;
    fields.range.value = value;
  });
});

IMask(amountOwedInput, {
  mask: Number,
  scale: 2,
  signed: false,
  thousandsSeparator: ",",
  padFractionalZeros: true,
  radix: ".",
  mapToRadix: ["."],
  normalizeZeros: true,
  min: 0,
  max: Number.MAX_SAFE_INTEGER,
  prepare: function (str) {
    return str.replace(/[^0-9.]/g, "");
  },
  overwrite: true,
});

const wait = async (duration = 500) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
};

const normalizeNumber = (input) => {
  return parseFloat(input.replaceAll(",", ""));
};

const toCurrency = (number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return formatter.format(number);
};

form.addEventListener("submit", async (e) => {
  e.preventDefault();

  let isValid = true;

  form.querySelectorAll("input[required]").forEach((field) => {
    if (!field.checkValidity()) {
      field.classList.add("has-error");
      isValid = false;

      field.addEventListener("input", () => field.classList.remove("has-error"), { once: true });
    } else {
      field.classList.remove("has-error");
    }
  });

  if (!isValid) {
    scrollToIfNeeded(form, 32);

    return;
  }

  const submitBtn = form.querySelector('[type="submit"]');

  const data = new FormData(form);

  const totalBase = normalizeNumber(data.get("total_base"));
  const percentMonthlyChurn = normalizeNumber(data.get("percent_monthly_churn"));
  const amountOwed = normalizeNumber(data.get("amount_owed"));
  const reduceBadDebtLowPercentage = parseFloat(calculatorData.reduce_bad_debt_low_percentage) / 100;
  const reduceBadDebtHighPercentage = parseFloat(calculatorData.reduce_bad_debt_high_percentage) / 100;

  const totalMonthlyChurn = totalBase * (percentMonthlyChurn / 100);
  const annualBadDebtExposure = amountOwed * totalMonthlyChurn * 12;
  const lowAnnualRevenueReturn =
    totalMonthlyChurn * amountOwed * (1 / (percentMonthlyChurn / 100)) * reduceBadDebtLowPercentage * 12;
  const highAnnualRevenueReturn =
    totalMonthlyChurn * amountOwed * (1 / (percentMonthlyChurn / 100)) * reduceBadDebtHighPercentage * 12;

  form.querySelector(".annual-bad-debt-amount").textContent = toCurrency(annualBadDebtExposure);
  form.querySelector(".low-annual-revenue-amount").textContent = toCurrency(lowAnnualRevenueReturn);
  form.querySelector(".high-annual-revenue-amount").textContent = toCurrency(highAnnualRevenueReturn);

  submitBtn.disabled = true;
  submitBtn.classList.add("is-loading");

  await wait();

  if (!form.classList.contains("has-results")) {
    await slideDown(results);
  }

  scrollToIfNeeded(results, 32);

  headline.textContent = headline.dataset.resultsLabel;
  form.classList.add("has-results");
  submitBtn.disabled = false;
  submitBtn.classList.remove("is-loading");
  submitBtn.querySelector("span").textContent = "Update Calculation";

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "form_submit",
      form_type: "ROI Calculator Form",
    });
  }
});
